export type HomeLocationMode = 'all' | 'fixed' | 'gps';

export function areHomeFeedFiltersActive(
  favoritesOnly: boolean,
  locationMode: HomeLocationMode
): boolean {
  return favoritesOnly || locationMode !== 'all';
}
